import api from '../utils/api';

// ==================== AUTH ====================
export const login = (opts) =>
  api.post('/auth/login', opts);

export const changePassword = (opts) =>
  api.post('/auth/change-password', opts);

// ==================== RESULTS ====================
export const getResults = (params) =>
  api.get('/admin/results', { params });

export const getResultAnswers = (id) =>
  api.get(`/admin/results/${id}/answers`);

// ==================== CANDIDATES ====================
export const getCandidates = () =>
  api.get('/admin/candidates');

export const createCandidate = (opts) =>
  api.post('/admin/candidates', opts);

export const bulkImportCandidates = (formData) =>
  api.post('/admin/candidates/bulk', formData);

export const resendCandidateEmail = (userId) =>
  api.post(`/admin/candidates/${userId}/resend-email`);

export const updateCandidateStatus = (userId, opts) =>
  api.patch(`/admin/candidates/${userId}/status`, opts);

export const deleteCandidate = (userId) =>
  api.delete(`/admin/candidates/${userId}`);

// ==================== QUESTIONS ====================
export const getQuestions = (params) =>
  api.get('/admin/questions', { params });

export const getQuestionStats = () =>
  api.get('/admin/questions/stats');

export const getQuestionCategories = () =>
  api.get('/admin/questions/categories');

export const createQuestion = (opts) =>
  api.post('/admin/questions', opts);

export const updateQuestion = (id, opts) =>
  api.put(`/admin/questions/${id}`, opts);

export const toggleQuestionStatus = (id, opts) =>
  api.patch(`/admin/questions/${id}/status`, opts);

export const deleteQuestion = (id) =>
  api.delete(`/admin/questions/${id}`);

export const uploadQuestionImage = (formData) =>
  api.post('/admin/upload-image', formData);

export const bulkImportQuestions = (questions) =>
  api.post('/admin/questions/bulk', { questions });

// ==================== TEST CONFIG ====================
export const getTestConfigs = () =>
  api.get('/admin/test-configs');

export const createTestConfig = (opts) =>
  api.post('/admin/test-configs', opts);

export const updateTestConfig = (id, opts) =>
  api.put(`/admin/test-configs/${id}`, opts);

export const activateTestConfig = (id) =>
  api.patch(`/admin/test-configs/${id}/activate`);

// ==================== EMAIL SETTINGS ====================
export const getEmailConfig = () =>
  api.get('/admin/email-configs');

export const updateEmailConfig = (opts) =>
  api.put('/admin/email-configs', opts);

export const testEmailConnection = (opts) =>
  api.post('/admin/email-configs/test', opts);

// ==================== ADMINS ====================
export const getAdmins = () =>
  api.get('/admin/admins');

export const createAdmin = (opts) =>
  api.post('/admin/admins', opts);

export const updateAdmin = (id, opts) =>
  api.patch(`/admin/admins/${id}`, opts);

export const resendAdminEmail = (id) =>
  api.post(`/admin/admins/${id}/resend-email`);

export const deleteAdmin = (id) =>
  api.delete(`/admin/admins/${id}`);

// ==================== ROLES ====================
export const getRoles = () =>
  api.get('/admin/roles');

export const createRole = (opts) =>
  api.post('/admin/roles', opts);

export const updateRole = (id, opts) =>
  api.put(`/admin/roles/${id}`, opts);

export const deleteRole = (id) =>
  api.delete(`/admin/roles/${id}`);

// ==================== COMPANY SETTINGS ====================
export const getCompany = () =>
  api.get('/admin/company');

export const updateCompany = (opts) =>
  api.put('/admin/company', opts);

// ==================== TEST (CANDIDATE) ====================
export const startTest = (opts) =>
  api.post('/test/start', opts);

export const submitAnswer = (opts) =>
  api.post('/test/answer', opts);

export const submitTest = (opts) =>
  api.post('/test/submit', opts);

export const reportViolation = (opts) =>
  api.post('/test/violation', opts);
